import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const emailConfigurationDetails = createAsyncThunk('email_configuration/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `email_setup/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addEmailConfiguration = createAsyncThunk('email_configuration/add', async (data) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'email_setup',
            data: {
                premise_id: data?.values?.premise,
                smtp_host: data?.values?.smtpHost,
                smtp_port: data?.values?.smtpPort,
                smtp_user: data?.values?.smtpUser,
                smtp_password: data?.values?.smtpPassword,
                smtp_secure: data?.values?.smtpSecure,
                smtp_encryption: data?.values?.smtpEncryption,
                mail_driver: data?.values?.mailDriver,
                mail_from_email: data?.values?.mailFromEmail,
                mail_from_name: data?.values?.mailFromName,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const emailConfiguration = createSlice({
    name: 'email_configuration',
    initialState: {
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(emailConfigurationDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        });
    }
})

export default emailConfiguration.reducer;